import CssBaseline from "@mui/material/CssBaseline";
import AdminSidebar from "components/admin/AdminSidebar";
import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import SharePriceTable from "components/datagrid/SharePriceTable";

const SharePriceHistory = () => {
  const [sharePrice, setSharePrice] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const fetchSharePriceHistory = async () => {
    setLoading(true);
    try {
      const { data } = await apis.getSharePriceHistory();
      if (data?.status) {
        setSharePrice(data?.sharePrice);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchSharePriceHistory();
    })();
  }, []);

  const { rows, columns } = SharePriceTable(sharePrice);

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
                {/* <h3 className="dashboard-title">{t("titles.share_price")}</h3> */}
                <Grid
                  item
                  container
                  className="mt-4"
                  justifyContent="flex-end"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default SharePriceHistory;
